import { Box } from '@chakra-ui/react';

import { CoachSidebarClosed } from 'app/layout/components/Layout/CoachSidebar/CoachSidebarClosed';
import { CoachSidebarOpen } from 'app/layout/components/Layout/CoachSidebar/CoachSidebarOpen';
import { useSidebarCollapseContext } from 'app/layout/context/drawer';

const CoachSidebar = () => {
  const { isOpen } = useSidebarCollapseContext();

  return (
    <Box transition="all 0.2s">
      {isOpen ? <CoachSidebarOpen /> : <CoachSidebarClosed />}
    </Box>
  );
};

export default CoachSidebar;
